import { hashCode, isValidDate } from "src/components/js/statics1";
import { sendTilausvahvistus_exported } from "./handleKeikka";
import mailClass from "../system/mailClass";
import stepLogClass from "../stepLog/stepLogClass";
import { deleteStepLogMessagesByType, confirmStepLogType } from "../stepLog/stepLogMessageClass";

export default class ProcessClass {
  constructor(keikkaData, personId) {
    this.personId = personId;
    this.keikkaData = keikkaData;
    this.stepLog = new stepLogClass(keikkaData.keikkaId);
    this.isImported = { confirmDate: null, isConfirmed: false };

    this._pumppuVarattu = undefined;
    this._betoniVarattu = undefined;
    this._tilausLähetetty = undefined;
    this._betonitoimijaTilausVastaanotettu = undefined;
    this._tyomaaOsoiteHyväksytty = undefined;
    this._asiakasHyväksytty = undefined;
    this._tilausToimitettu = undefined;
    this._kellonaikaVahvistettu = undefined;
    this._tilausvahvistusLähetetty = undefined;
    this.socket = undefined;
  }
  async initProcess(token, socket) {
    this.socket = socket;
    await this.stepLog.init(token, socket);
    // isImported = jos on tuotu pumi.fi:stä
    this.isImported = this.stepLog.isImported;
  }
  // #region tilaus:luonti aloitettu
  get luontiAloitettu() {
    if (this._luontiAloitettu === undefined) {
      this._luontiAloitettu = this.stepLog.getStepLogTypeStatus(15);
      this._luontiAloitettu.isConfirmed = true;
    }
    return this._luontiAloitettu;
  }
  // #endregion
  // #region kellonaika valittu -> käsittely:Toimitusajankohta hyväksytty
  // tilaus:kellonaika valitu
  get kellonaikaValittu() {
    return { isConfirmed: isValidDate(this.keikkaData.pumppu.pumppuAika) };
  }
  // käsittely: Toimitusajankohta hyväksytty
  get kellonaikaVahvistettu() {
    if (this.isImported.isConfirmed) {
      return { isConfirmed: true, confirmDate: this.isImported.confirmDate };
    }
    if (this._kellonaikaVahvistettu === undefined) {
      this._kellonaikaVahvistettu = this.stepLog.getStepLogTypeStatus(17);
    }
    return this._kellonaikaVahvistettu;
  }
  kellonAikaVahvista() {
    confirmStepLogType(this.keikkaData.keikkaId, 17, this.socket, true);
    this._kellonaikaVahvistettu.isConfirmed = true;
    this._kellonaikaVahvistettu.confirmDate = new Date();
  }
  kellonAikaHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 17, this.socket);
    this._kellonaikaVahvistettu.isConfirmed = false;
    this._kellonaikaVahvistettu.confirmDate = null;
  }
  // #endregion
  // #region asiakas valittu -> käsittely:Asiakas hyväksytty
  get asiakasValittu() {
    return { isConfirmed: this.keikkaData.asiakas.asiakasId > 0 ? true : false };
  }
  asiakasHyväksy() {
    confirmStepLogType(this.keikkaData.keikkaId, 19, this.socket, true);
    this._asiakasHyväksytty.isConfirmed = true;
    this._asiakasHyväksytty.confirmDate = new Date();
  }
  asiakasHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 19, this.socket);
    this._asiakasHyväksytty.isConfirmed = false;
    this._asiakasHyväksytty.confirmDate = null;
  }
  get asiakasHyväksytty() {
    if (this._asiakasHyväksytty === undefined)
      this._asiakasHyväksytty = this.stepLog.getStepLogTypeStatus(19);
    return this._asiakasHyväksytty;
  }
  // #endregion
  // #region osoite valittu -> käsittely:Työmaaosoite hyväksytty -> tilaus:betoinitoimijat valittu
  get toimitusOsoiteValittu() {
    return { isConfirmed: this.keikkaData.tyomaa.tyomaaOsoite1 ? true : false };
  }
  get tyomaaOsoiteHyväksytty() {
    if (this._tyomaaOsoiteHyväksytty === undefined)
      this._tyomaaOsoiteHyväksytty = this.stepLog.getStepLogTypeStatus(18);
    return this._tyomaaOsoiteHyväksytty;
  }
  async toimitusOsoiteHyväksy() {
    await confirmStepLogType(this.keikkaData.keikkaId, 18, this.socket, true);
  }
  toimitusOsoiteHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 18, this.socket);
  }
  get betoniToimijatValittu() {
    return {
      isConfirmed:
        this.keikkaData.betoniToimittaja.asiakasId > 0 &&
        this.keikkaData.pumppuToimittaja.asiakasId > 0,
    };
  }
  // #endregion
  // #region puomi ja linja valittu
  get puomiValittu() {
    return {
      isConfirmed: this.keikkaData.pumppu.puomiError() ? false : true,
    };
  }
  get linjaValittu() {
    return {
      isConfirmed: this.keikkaData.pumppu.linjaError() ? false : true,
    };
  }
  // #endregion
  // #region betonimäärä valittu
  get betoniMääräTäytetty() {
    if (this.keikkaData.betoni.length === 0) return { isConfirmed: false };
    for (let i = 0; i < this.keikkaData.betoni.length; i++) {
      if (this.keikkaData.betoni[i].m3 == null) return { isConfirmed: false };
    }
    return { isConfirmed: true };
  }
  // #endregion
  // #region betonilaatu valittu
  get betoniTiedotTäytetty() {
    if (this.keikkaData.betoni.length === 0) return { isConfirmed: false };
    for (let i = 0; i < this.keikkaData.betoni.length; i++) {
      if (this.keikkaData.betoni[i].betoniError()) return { isConfirmed: false };
    }
    return { isConfirmed: true };
  }
  // #endregion
  // #region tilaus lähetetty
  get tilausLähetetty() {
    if (this._tilausLähetetty === undefined)
      this._tilausLähetetty = this.stepLog.getStepLogTypeStatus(1);
    return this._tilausLähetetty;
  }
  // #endregion

  // #region käsittely:tilaus vastaanotettu
  get betonitoimijaTilausVastaanotettu() {
    if (this._betonitoimijaTilausVastaanotettu === undefined)
      this._betonitoimijaTilausVastaanotettu = this.stepLog.getStepLogTypeStatus(2);
    return this._betonitoimijaTilausVastaanotettu;
  }
  // #endregion
  // #region käsittely:Pumppu varattu
  get pumppuVarattu() {
    if (this.isImported.isConfirmed) return { isConfirmed: true };
    if (this._pumppuVarattu === undefined)
      this._pumppuVarattu = this.stepLog.getStepLogTypeStatus(6);
    return this._pumppuVarattu;
  }
  pumppuHyväksy() {
    confirmStepLogType(this.keikkaData.keikkaId, 6, this.socket, true);
    this._pumppuVarattu.isConfirmed = true;
    this._pumppuVarattu.confirmDate = new Date();
  }
  pumppuHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 6, this.socket);
    this._pumppuVarattu.isConfirmed = false;
    this._pumppuVarattu.confirmDate = null;
  }
  // #endregion
  // #region käsittely:Betoni varattu
  get betoniVarattu() {
    if (this.isImported.isConfirmed) return { isConfirmed: true };
    if (this._betoniVarattu === undefined)
      this._betoniVarattu = this.stepLog.getStepLogTypeStatus(5);
    return this._betoniVarattu;
  }
  betoniHyväksy() {
    confirmStepLogType(this.keikkaData.keikkaId, 5, this.socket, true);
    this._betoniVarattu.isConfirmed = true;
    this._betoniVarattu.confirmDate = new Date();
  }
  betoniHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 5, this.socket);
    this._betoniVarattu.isConfirmed = false;
    this._betoniVarattu.confirmDate = null;
  }
  // #endregion
  // #region toimitus:tilaus on toimitusvalmis
  get tilausHyväksytty() {
    if (this._tilausHyväksytty === undefined)
      this._tilausHyväksytty = this.stepLog.getStepLogTypeStatus(3);
    return this._tilausHyväksytty;
  }
  tilausHyväksy() {
    // pumppuToimittajaHyväksyyTilauksen(this.keikkaData, this.personId, token);
    confirmStepLogType(this.keikkaData.keikkaId, 3, this.socket, true);
    this._tilausHyväksytty.isConfirmed = true;
    this._tilausHyväksytty.confirmDate = new Date();
  }
  tilausHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 3, this.socket);
    this._tilausHyväksytty.isConfirmed = false;
    this._tilausHyväksytty.confirmDate = null;
  }
  // #endregion
  // #region toimitus:tilausvahvistus lähetetty
  get tilausvahvistusLähetetty() {
    if (this._tilausvahvistusLähetetty === undefined)
      this._tilausvahvistusLähetetty = this.stepLog.isTilausvahvistusLähetetty;
    return this._tilausvahvistusLähetetty;
  }

  tilausvahvistusLähetä(token, socket) {
    const thisMail = new mailClass(this.keikkaData);
    thisMail.emailToEmail = this.keikkaData.pumppuToimittaja.asiakasContactPersonEmail;
    sendTilausvahvistus_exported(thisMail, this.keikkaData, this.personId, token, socket);
  }

  tilausvahvistusHyväksy() {
    confirmStepLogType(this.keikkaData.keikkaId, 20, this.socket, true);
    this._tilausvahvistusLähetetty.isConfirmed = true;
    this._tilausvahvistusLähetetty.confirmDate = new Date();
  }
  tilausvahvistusHylkää() {
    deleteStepLogMessagesByType(this.keikkaData.keikkaId, 20, this.socket);
    this._tilausvahvistusLähetetty.isConfirmed = false;
    this._tilausvahvistusLähetetty.confirmDate = null;
  }
  // #endregion
  // #region toimitus:tilaus on toimitettu
  get tilausToimitettu() {
    if (this._tilausToimitettu === undefined) {
      this._tilausToimitettu = this.stepLog.getStepLogTypeStatus(21);
      if (!this._tilausToimitettu.isConfirmed && this.keikkaData.tila.keikkaTilaId == 9)
        this._tilausToimitettu.isConfirmed = true;
    }
    return this._tilausToimitettu;
  }
  //#endregion

  // #region percentages
  get asiakasLuoTilaustaPercent() {
    let cnt = 9;
    let done = 0;

    /* luonti aloitettu */
    if (this.luontiAloitettu.isConfirmed) done++;
    /* asiakas valittu */
    if (this.keikkaData.asiakas.asiakasId > 0) done++;
    /* Toimitusosoite valittu */
    if (this.keikkaData.tyomaa.tyomaaId > 0) done++;
    /* betonivalmistaja valittu */
    if (this.keikkaData.betoniToimittaja.asiakasId > 0) done++;
    /* pumpputpimittaja valittu */
    if (this.keikkaData.betoniToimittaja.asiakasId > 0) done++;
    /* puomi valittu */
    if (this.keikkaData.pumppu.isPuomiSelected) done++;
    /* linja valittu */
    if (this.keikkaData.pumppu.isLinjaSelected) done++;
    /* kellonaika valittu */
    if (this.kellonaikaValittu.isConfirmed) done++;
    /* betonitiedot valittu */
    for (let i = 0; i < this.keikkaData.betoni.length; i++) {
      const betoni = this.keikkaData.betoni[i];
      cnt++;
      if (betoni.m3 > 0) done++;
      cnt++;
      if (betoni.laatuError() === null) done++;
      cnt++;
      if (betoni.rasitusError() === null) done++;
    }
    /* tilaus lähetetty */
    if (this.tilausLähetetty.isConfirmed) done++;

    const c = Math.round((done / cnt) * 100);
    return c;
  }
  get betoniToimijaKäsitteleeTilaustaPercent() {
    const cnt = 8;
    let done = 0;

    if (this.betonitoimijaTilausVastaanotettu.isConfirmed) done++;
    if (this.tyomaaOsoiteHyväksytty.isConfirmed) done++;
    if (this.asiakasHyväksytty.isConfirmed) done++;
    if (this.tilausHyväksytty.isConfirmed) done++;
    if (this.pumppuVarattu.isConfirmed) done++;
    if (this.betoniVarattu.isConfirmed) done++;
    if (this.kellonaikaVahvistettu.isConfirmed) done++;
    if (this.tilausvahvistusLähetetty.isFound) done++;
    return Math.round((done / cnt) * 100);
  }
  get tilausToimitetaanPercent() {
    const cnt = 2;
    let done = 0;
    if (this.tilausHyväksytty.isConfirmed) done++;
    if (this.tilausToimitettu.isConfirmed) done++;
    return Math.round((done / cnt) * 100);
  }
  // #endregion
  get hash() {
    let _json = "";
    _json += JSON.stringify(this._pumppuVarattu);
    _json += JSON.stringify(this._betoniVarattu);
    _json += JSON.stringify(this._tilausLähetetty);
    _json += JSON.stringify(this._betonitoimijaTilausVastaanotettu);
    _json += JSON.stringify(this._tyomaaOsoiteHyväksytty);
    _json += JSON.stringify(this._asiakasHyväksytty);
    _json += JSON.stringify(this._tilausToimitettu);
    _json += JSON.stringify(this._tilausHyväksytty);
    _json += JSON.stringify(this._kellonaikaVahvistettu);
    _json += JSON.stringify(this._tilausVas);
    _json += JSON.stringify(this._tilausvahvistusLähetetty);
    _json += JSON.stringify(this._luontiAloitettu);
    _json += JSON.stringify(this._kellonaikaValittu);
    const _hash = hashCode(_json);
    return _hash;
  }
}
